// ________________________________________________________
// #######################################################
//──│ 1. Imports
//  └──│ 1.1. Vendors
//  └──│ 1.2. Functions
//──│ 2. Global variables
//  └──│ 2.1. jQuery
//──│ 3. Init
//  └──│ 3.1.
// ________________________________________________________
// #######################################################
import rispoGrid from "./functions/rispoGrid";

jQuery(document).ready(function ($) {
  //──│ 2. Global variables
  //  └──│ 2.1. jQuery
  global.$ = $;

  init();
});

function init() {
  rispoGrid();
}
